export { default as component } from "../../../../src/routes/[prefix]/(feature)/activity-recap/+page.svelte";